import merge from 'lodash.merge';

import sharedScreen from '#frontend/singleDataLayer/shared/screen.js';
import productList from '#frontend/singleDataLayer/shared/productList.js';

/**
 * Cross pop event object
 * @param {object} cart cart data object
 * @returns {object} merged sdl object
 */
export default (cart) => {
	const screen = {
		screen: {
			type: 'list',
			section: 'Offers',
			name: 'CrossPop',
			productLists: [productList(cart, cart.order.impressions, 'cart.crosspop')]
		}
	};

	return merge(screen, sharedScreen(cart));
};
